<template>
<v-container app :fluid="true" class="pt-0">
    <v-row>
        <v-col cols="3">
            <v-autocomplete
                :items="providers"
                dense
                solo
                clearable 
                clear-icon="far fa-times-circle"               
                label="Proveedores"
                persistent-hint
                :item-text="customText"
                item-value="id"
                hide-details
                @change="handleSelecteProvider"
                :filter="customFilter"
            >
                <template v-slot:item="data">
                    <v-list-item-content>
                        <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                        <v-list-item-subtitle>RUC: {{ data.item.document }}</v-list-item-subtitle>
                    </v-list-item-content>
                </template>
            </v-autocomplete>
        </v-col>

        <v-col cols="3">
            <v-menu
                v-model="menuFromDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="from_date"
                    label="Desde"
                    dense
                    solo
                    readonly
                    clearable
                    v-on="on"
                    @click:clear="handleClearFrom"
                    hide-details                                    
                    ></v-text-field>
                </template>
                <v-date-picker v-model="from_date" @input="menuFromDate = false" no-title @change="handleChangeFormDate">
                </v-date-picker>
            </v-menu>
        </v-col>

        <v-col cols="3">
            <v-menu
                v-model="menuUntilDate"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
            >
                <template v-slot:activator="{ on }">
                    <v-text-field
                    v-model="until_date"
                    label="Hasta"
                    solo
                    dense
                    readonly
                    clearable
                    v-on="on"
                    @click:clear="handleClearUntil"
                    hide-details
                    ></v-text-field>
                </template>
                <v-date-picker v-model="until_date" @input="menuUntilDate = false" no-title @change="handleChangeUntilDate"></v-date-picker>
            </v-menu>
        </v-col>

        <v-col cols="3">
            <v-btn dark color="green" 
                @click="handleExportExcel"
                v-if="verifyPermission('exportar_reporte_compras')">
                XLS
            </v-btn>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="12">
            <v-card>
                <template>
                    <v-row>
                        <v-col cols="12" class="pt-1">
                            <v-data-table
                                class="wost-table"
                                :headers="headers"
                                :items="purchases"
                                item-key="id"
                                height="65vh"
                                show-expand
                                :single-expand="true"
                                fixed-header
                            >
                                <template v-slot:item.voucher_date="{item}">
                                    {{ item.voucher_date | moment("DD/MM/YYYY") }}
                                </template>
                                <template v-slot:item.provider_id="{item}">
                                    {{ item.provider.name }}
                                </template>
                                <template v-slot:item.total="{item}">
                                    {{ item.total | currency('S/') }}
                                </template>
                                <template v-slot:item.is_credit="{item}">
                                    <span v-if="item.is_credit" class="purchases-type type-credito mr-1">Crédito</span>                                                
                                    <span v-else class="purchases-type type-contado">Contado</span>
                                    <span v-if="item.is_credit" :class="'purchases-paid purchase-'+getCondition(item)">
                                        {{ getCondition(item) }}
                                    </span>
                                </template>
                                <template v-slot:item.payment_date="{item}">
                                    <span v-if="item.is_credit">
                                        {{ item.payment_date | moment("DD/MM/YYYY") }}
                                    </span>
                                </template>

                                <template v-slot:expanded-item="{ item, headers }">
                                    <td :colspan="headers.length" class="wost-td-expanded">
                                        <purchase-detail :purchase="item" :supplies="item.supplies"></purchase-detail>
                                    </td>
                                </template>

                            </v-data-table>                            
                        </v-col>
                    </v-row>
                </template>
            </v-card>
        </v-col>
    </v-row>
</v-container>
    
</template>

<script>
import XLSX from 'xlsx'

import ApiReports from '../../apis/Reports'

import PurchaseDetail from '../../components/Reports/PurchaseDetail'
import Tools from '../../helpers/Tools'

import {APIService} from '@/APIService';

const apiService = new APIService();

export default {
    name: 'Purchases',
    components: {
        PurchaseDetail
    },
    data() {
        return {
            headers: [
                { text: 'Fecha', value: 'voucher_date', align: 'left', sortable: false, class: 'header-table'},
                { text: 'Proveedor', value: 'provider_id', align: 'left', sortable: false, class: 'header-table' },
                { text: 'serie', value: 'serie', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Número', value: 'correlative', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Total', value: 'total', align: 'left', sortable: false, class: 'header-table' },
                { text: 'Tipo', value: 'is_credit', sortable: false, class: 'header-table' },
                { text: 'F. Vencimiento', value: 'payment_date', sortable: false, class: 'header-table' },
                { text: '', value: 'data-table-expand', width: 10, class: 'header-table-expand' }
            ],
            purchases: [],
            providers: [],
            menuFromDate: false,
            from_date: null,
            menuUntilDate: false,
            until_date: null
        }
    },
    methods: {
        getPurchases() {
            let params = {
                provider_id: this.provider_id,
                from: this.from_date,
                until: this.until_date
            }
            
            ApiReports.purchases(params)
                    .then(({data}) => {
                        this.purchases = data
                    })
        },
        getProviders() {
            apiService.getProviders()
                .then(({data}) => {
                    this.providers = data
                })
        },
        customText(item){
            let text = item.name
            
            return text
        },
        customFilter(item, queryText, itemText) {
            let textName = '';
            if (item.name) {
                textName = item.name.toLowerCase();             
            }

            let textDocument = '';
            if (item.document) {
                textDocument = item.document.toLowerCase();             
            }
            let searchText = queryText.toLowerCase()

            return textName.indexOf(searchText) > -1 || textDocument.indexOf(searchText) > -1
        },
        handleSelecteProvider(value){            
            this.provider_id = null            
            if(value !== undefined && value !== null){
                this.provider_id = value
            }
            this.getPurchases()
        },
        handleClearFrom(){
            this.from_date = null
            this.getPurchases()
        },
        handleClearUntil(){
            this.until_date = null
            this.getPurchases()
        },
        handleChangeFormDate(){
            this.getPurchases()
        },
        handleChangeUntilDate(){
            this.getPurchases()
        },
        handleViewDebtDetail(purchase){
            this.$refs.purchaseDetail.showForm('Detalle de Compra', purchase)
        },
        getCondition(purchase){
            let condition = ''
            if (purchase.is_credit) {
                let expiration_date = Tools.setFormatDate(new Date(purchase.payment_date))
                if (purchase.is_paid) {
                    condition = 'pagada'
                } else {
                    condition = 'pendiente'
                    let currentDate = Tools.prepareCurrentDate()
                    if(new Date(currentDate) > new Date(purchase.payment_date)){
                        condition = 'vencida'
                    }                        
                }
            }
            return condition
        },
        handleExportExcel(){
            let data = XLSX.utils.json_to_sheet(
                this.prepareDataExport(this.purchases),
                {
                    header: ['voucher_date', 'provider', 'serie', 'correlative', 'total', 'type', 'status', 'expiration_date']
                }
            )
            data['A1'].v = 'Fecha de Compra'
            data['B1'].v = 'Proveedor'
            data['C1'].v = 'Serie'
            data['D1'].v = 'Número'
            data['E1'].v = 'Total'
            data['F1'].v = 'Tipo'
            data['G1'].v = 'Estado'
            data['H1'].v = 'Fecha de Vencimiento'
            const workbook = XLSX.utils.book_new()
            const filename = 'reporte-de-compras'
            XLSX.utils.book_append_sheet(workbook, data, filename)
            XLSX.writeFile(workbook, `${filename}.xls`)
        },
        prepareDataExport(purchases){
            let dataExport = []
            purchases.forEach(element => {
                let type = 'Contado'
                let status = ''
                let expiration_date = ''
                if (element.is_credit) {
                    type = 'Crédito'
                    expiration_date = Tools.setFormatDate(new Date(element.payment_date))
                    if (element.is_paid) {
                        status = 'Pagada'
                    } else {
                        status = 'Pendiente'
                        let currentDate = Tools.prepareCurrentDate()
                        if(new Date(currentDate) > new Date(element.payment_date)){
                            status = 'Vencida'
                        }                        
                    }
                }
                
                let itemData = {
                    voucher_date: Tools.setFormatDate(new Date(element.voucher_date)),
                    provider: element.provider.name,
                    serie: element.serie,
                    correlative: element.correlative,
                    total: element.total,
                    type: type,
                    status: status,
                    expiration_date: expiration_date
                }
                dataExport.push(itemData)
            })
            return dataExport
        },
        verifyPermission(permission) {
            return this.$hasPermision(permission)
        }
    },
    mounted() {
        this.getProviders()
        this.getPurchases()
    }
}
</script>

<style>
.purchases-type{
    display: inline-block;
    width: 80px;
    text-align: center;
    border-radius: 4px;
    font-size: 13px;
}

.type-credito {
    background-color: #2196F3;
    color: #ffffff;
}

.type-contado {
    background-color: #4CAF50;
    color: #ffffff;
}

.purchases-paid{
    display: inline-block;
    width: 80px;
    text-align: center;
    border-radius: 4px;
    font-size: 13px;
}

.purchase-pagada{
    color: #43A047 !important;
    font-weight: 500;
    border: 1px solid;
}

.purchase-pendiente{
    color: #FFC107 !important;
    font-weight: 500;
    border: 1px solid;
}

.purchase-vencida{
    color: #F44336 !important;
    font-weight: 500;
    border: 1px solid;
}
</style>